import { Type } from "@angular/core";
import { BasicFooterComponent } from "@modules/+new/shared/universal-modal/components/_footers/basic/basic-footer.component";

type ModalFootersComponentTypes = BasicFooterComponent;
export enum ModalFootersEnum {
	basic = "basic"
}

export const ModalFootersIndex: Record<ModalFootersEnum, Type<ModalFootersComponentTypes>> = {
	[ModalFootersEnum.basic]: BasicFooterComponent
};
